<template>
  <div class="flex flex-col h-full">
    <job-menu :job="job"></job-menu>

    <div class="my-10 h-full flex flex-col justify-between flex-1">
      <div class="flex justify-center px-4 items-center">
        <h1 class="text-3xl font-bold text-center">{{ __('Job :id conversation', {'id': job.id}) }}</h1>
      </div>

      <chat class="my-5" :job="job" :conversation="conversation" :messages="messages"></chat>
    </div>
  </div>
</template>

<script>
import Chat from "../../Shared/Chat";
import Layout from "../../Shared/Layout";
import JobMenu from "./JobMenu";

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__("Jobs")
    };
  },
  props: {
    job: Object,
    messages: Object,
    conversation: Object
  },
  components: {
    Layout,
    Chat,
    JobMenu
  }
};
</script>
